



export const limitedSizes = [
	{
		display: '5.50',
		value: '5.50',
	},
	{
		display: '5.75',
		value: '5.75',
	},
	{
		display: '6.00',
		value: '6.00',
	},
	{
		display: '6.25',
		value: '6.25',
	},
	{
		display: '6.50',
		value: '6.50',
	},
	{
		display: '6.75',
		value: '6.75',
	},
	{
		display: '7.00',
		value: '7.00',
	},
	{
		display: '7.25',
		value: '7.25',
	},
	{
		display: '7.50',
		value: '7.50',
	},
];

export const eternitySizes = [
	{
		display: '4.00',
		value: '4.00',
	},
	{
		display: '4.50',
		value: '4.50',
	},
	{
		display: '5.00',
		value: '5.00',
	},
	{
		display: '5.50',
		value: '5.50',
	},
	{
		display: '6.00',
		value: '6.00',
	},
	{
		display: '6.50',
		value: '6.50',
	},
	{
		display: '7.00',
		value: '7.00',
	},
	{
		display: '7.50',
		value: '7.50',
	},
];


export const ringSizes = [
	{
		display: '3.00',
		value: '3.00',
	},
	{
		display: '3.25',
		value: '3.25',
	},
	{
		display: '3.50',
		value: '3.50',
	},
	{
		display: '3.75',
		value: '3.75',
	},
	{
		display: '4.00',
		value: '4.00',
	},
	{
		display: '4.25',
		value: '4.25',
	},
	{
		display: '4.50',
		value: '4.50',
	},
	{
		display: '4.75',
		value: '4.75',
	},
	{
		display: '5.00',
		value: '5.00',
	},
	{
		display: '5.25',
		value: '5.25',
	},
	{
		display: '5.50',
		value: '5.50',
	},
	{
		display: '5.75',
		value: '5.75',
	},
	{
		display: '6.00',
		value: '6.00',
	},
	{
		display: '6.25',
		value: '6.25',
	},
	{
		display: '6.50',
		value: '6.50',
	},
	{
		display: '6.75',
		value: '6.75',
	},
	{
		display: '7.00',
		value: '7.00',
	},
	{
		display: '7.25',
		value: '7.25',
	},
	{
		display: '7.50',
		value: '7.50',
	},
	{
		display: '7.75',
		value: '7.75',
	},
	{
		display: '8.00',
		value: '8.00',
	},
	{
		display: '8.25',
		value: '8.25',
	},
	{
		display: '8.50',
		value: '8.50',
	},
	{
		display: '8.75',
		value: '8.75',
	},
	{
		display: '9.00',
		value: '9.00',
	},
	{
		display: '9.25',
		value: '9.25',
	},
	{
		display: '9.50',
		value: '9.50',
	},
	{
		display: '9.75',
		value: '9.75',
	},
	{
		display: '10.00',
		value: '10.00',
	},
	{
		display: '10.25',
		value: '10.25',
	},
	{
		display: '10.50',
		value: '10.50',
	},
	{
		display: '10.75',
		value: '10.75',
	},
	{
		display: '11.00',
		value: '11.00',
	},
	{
		display: '11.25',
		value: '11.25',
	},
	{
		display: '11.50',
		value: '11.50',
	},
	{
		display: '11.75',
		value: '11.75',
	},
	{
		display: '12.00',
		value: '12.00',
	},
	{
		display: '12.25',
		value: '12.25',
	},
	{
		display: '12.50',
		value: '12.50',
	},
	{
		display: '12.75',
		value: '12.75',
	},
	{
		display: '13.00',
		value: '13.00',
	},
	{
		display: '13.25',
		value: '13.25',
	},
	{
		display: '13.50',
		value: '13.50',
	},
	{
		display: '13.75',
		value: '13.75',
	},
	{
		display: '14.00',
		value: '14.00',
	},
];

export const ringSizesMen = [
	{
		display: '7.00',
		value: '7.00',
	},
	{
		display: '7.25',
		value: '7.25',
	},
	{
		display: '7.50',
		value: '7.50',
	},
	{
		display: '7.75',
		value: '7.75',
	},
	{
		display: '8.00',
		value: '8.00',
	},
	{
		display: '8.25',
		value: '8.25',
	},
	{
		display: '8.50',
		value: '8.50',
	},
	{
		display: '8.75',
		value: '8.75',
	},
	{
		display: '9.00',
		value: '9.00',
	},
	{
		display: '9.25',
		value: '9.25',
	},
	{
		display: '9.50',
		value: '9.50',
	},
	{
		display: '9.75',
		value: '9.75',
	},
	{
		display: '10.00',
		value: '10.00',
	},
	{
		display: '10.25',
		value: '10.25',
	},
	{
		display: '10.50',
		value: '10.50',
	},
	{
		display: '10.75',
		value: '10.75',
	},
	{
		display: '11.00',
		value: '11.00',
	},
	{
		display: '11.25',
		value: '11.25',
	},
	{
		display: '11.50',
		value: '11.50',
	},
	{
		display: '11.75',
		value: '11.75',
	},
	{
		display: '12.00',
		value: '12.00',
	},
	{
		display: '12.25',
		value: '12.25',
	},
	{
		display: '12.50',
		value: '12.50',
	},
	{
		display: '12.75',
		value: '12.75',
	},
	{
		display: '13.00',
		value: '13.00',
	}
];

export const ringSizesWomen = [
	{
		display: '4.00',
		value: '4.00',
	},
	{
		display: '4.25',
		value: '4.25',
	},
	{
		display: '4.50',
		value: '4.50',
	},
	{
		display: '4.75',
		value: '4.75',
	},
	{
		display: '5.00',
		value: '5.00',
	},
	{
		display: '5.25',
		value: '5.25',
	},
	{
		display: '5.50',
		value: '5.50',
	},
	{
		display: '5.75',
		value: '5.75',
	},
	{
		display: '6.00',
		value: '6.00',
	},
	{
		display: '6.25',
		value: '6.25',
	},
	{
		display: '6.50',
		value: '6.50',
	},
	{
		display: '6.75',
		value: '6.75',
	},
	{
		display: '7.00',
		value: '7.00',
	},
	{
		display: '7.25',
		value: '7.25',
	},
	{
		display: '7.50',
		value: '7.50',
	},
	{
		display: '7.75',
		value: '7.75',
	},
	{
		display: '8.00',
		value: '8.00',
	},
	{
		display: '8.25',
		value: '8.25',
	},
	{
		display: '8.50',
		value: '8.50',
	},
	{
		display: '8.75',
		value: '8.75',
	},
	{
		display: '9.00',
		value: '9.00',
	},
	{
		display: '9.25',
		value: '9.25',
	},
	{
		display: '9.50',
		value: '9.50',
	},
	{
		display: '9.75',
		value: '9.75',
	},
	{
		display: '10.00',
		value: '10.00',
	}
];

export const ringFingers = [
	{
		display: 'Left index',
		value: 'Left index',
	},
	{
		display: 'Left middle',
		value: 'Left middle',
	},
	{
		display: 'Left ring',
		value: 'Left ring',
	},
	{
		display: 'Left pinky',
		value: 'Left pinky',
	},
	{
		display: 'Left thumb',
		value: 'Left thumb',
	},
	{
		display: 'Right index',
		value: 'Right index',
	},
	{
		display: 'Right middle',
		value: 'Right middle',
	},
	{
		display: 'Right ring',
		value: 'Right ring',
	},
	{
		display: 'Right pinky',
		value: 'Right pinky',
	},
	{
		display: 'Right thumb',
		value: 'Right thumb',
	},
];


// WEBPACK FOOTER //
// ./src/constants/ringsizes.jsx